import styles from './App.module.scss';
// react
import React, { Suspense, useEffect, useState } from 'react';
// router
import { Routes, Route } from 'react-router-dom';
// pages
import { LoginStudentPage } from './pages/student/loginStudentPage/index';
import { Dashboard } from './pages/student/index';
import { StudentDataView } from './pages/student/studentDataView/index';
import { StudentDataEnter } from './pages/student/studentDataEnter/index';
import { FormsDownloadPage } from './pages/student/formsDownloadPage';
import { DocumentDownloadPage } from './pages/student/documentDownloadPage/index';
import { QuizPage } from './pages/student/quizPageStudent/index';
import { StudentAppointment } from './pages/student/studentAppoint/index';
// admin
import { Admin } from './pages/admin/index';
import { LoginPage } from './pages/loginPage/index';
import { StudentsInfo } from './pages/admin/studentsInfo/index';
import { StatisticsPage } from './pages/admin/statisticsPage';
import { UpdateAccountInfo } from './pages/admin/updateAccountInfo';
import { UploadStudentInfoPage } from './pages/admin/uploadStudentData';
import { DeleteStudentInfoPage } from './pages/admin/deleteStudentData';
import { AdminsManagementPage } from './pages/admin/adminsManagementPage';
import { ChangePassword } from './pages/admin/changePassword';
import { SchedulePage } from './pages/admin/schedulePage/index';
// cookies
// components
import { Header } from './components/header/index';
import { Message } from './components/message/index';
// mui
import CircularProgress from '@mui/material/CircularProgress';
function App() {
  // get role from redux
  useEffect(() => {}, []);
  return (
    <div className={styles['main-container']}>
      <Header title={'طلب الالتحاق'} />
      <Suspense
        fallback={
          <CircularProgress
            size={20}
            sx={{
              color: '#fff',
            }}
          />
        }
      >
        <Routes>
          <Route path='' element={<LoginStudentPage />} />
          <Route path='/dashboard/*' element={<Dashboard />}>
            <Route path='quiz' element={<QuizPage />} />
            <Route path='studentDataView' element={<StudentDataView />} />
            <Route path='studentDataEnter' element={<StudentDataEnter />} />
            <Route path='studentAppointment' element={<StudentAppointment />} />
            <Route path='formsDownload' element={<FormsDownloadPage />} />
            <Route
              path='documentDownloadPage'
              element={<DocumentDownloadPage />}
            />
            <Route
              path='*'
              element={
                <Message text='لم يتم العثور على هذه الصفحة' type={'error'} />
              }
            />
          </Route>
          <Route path='/admin/login' element={<LoginPage />} />
          <Route path='/admin/*' element={<Admin />}>
            <Route path='studentsInfo' element={<StudentsInfo />} />
            <Route path='statistics' element={<StatisticsPage />} />
            <Route
              path='uploadStudentInfo'
              element={<UploadStudentInfoPage />}
            />
            <Route
              path='deleteStudentInfo'
              element={<DeleteStudentInfoPage />}
            />
            <Route path='adminsManagement' element={<AdminsManagementPage />} />
            <Route path='updateAccountInfo' element={<UpdateAccountInfo />} />
            <Route path='changePassword' element={<ChangePassword />} />
            <Route path='schedule' element={<SchedulePage />} />
            <Route
              path='*'
              element={
                <Message text='لم يتم العثور على هذه الصفحة' type={'error'} />
              }
            />
          </Route>
          <Route
            path='*'
            element={
              <Message text='لم يتم العثور على هذه الصفحة' type={'error'} />
            }
          />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
